export default __webpack_public_path__ + "static/media/endPause.76612c08.mp3";